export { MyOspriTileComponent } from './myospri-tile.component';